export function replaceSpecialCharacters(obj) {
  return JSON.stringify(obj).replace(/\+|&|%/g, (match) => {
    switch (match) {
      case "+":
        return "%2B";
      case "&":
        return "%26";
      case "%":
        return "%25";
    }
  });
}

/*----------------------------- FILTERING ITEM's FIELDS BEFORE SENDING -------------------------*/

/*-- Checking if some fields has null in field_value ( we don't send such fields )*/
export function filterFields(fieldsToFilter = []) {
  return fieldsToFilter.filter((field) => field.field_value != null);
}

export function convertObjToUrlParams(obj = {}) {
  const entries = Object.entries(obj);
  if (!entries.length) return "";
  return `&${entries.map(([key, value]) => `${key}=${value}`).join("&")}`;
}
